import Alert from "../../../../../components/Alert/Alert"
import "./AddWorkflowForm.css"
import { AddWorkflowFormProps } from "./AddScopeWorkflowForm.types"
import useStagedAddWorkflow from "./useScopeAddWorkflow"
import Button from "../../../../../components/Button/Button"
import PlusIcon from "../../../../../media/PlusIcon"
import ScopeWorkflowFormType from "../../../../../utils/ScopeWorkflowFormType"

const AddWorkflowForm = (props: AddWorkflowFormProps) => {

  const { showForm, onHide, formType } = props

  const [{
    currentForm,
    forms,
    currentFormIndex,
    onSelectForm,
    onNext
  }] = useStagedAddWorkflow(props)

  return (
    <Alert showAlert={showForm} onClose={onHide}>
      <div className="add-workflow-form-container">
        <div className="scope-workflow-header">
          <div className="scope-workflow-breadcrumbs">
            {forms.map((form, index) => (
              <>
                {index <= currentFormIndex && (
                  <p
                    key={index}
                    onClick={() => onSelectForm(index)}
                  >
                    {`${form}/`}
                  </p>
                )}
              </>
            ))}
          </div>
          <div className="close-icon" onClick={onHide}>
            <PlusIcon />
          </div>
        </div>
        
        {currentForm}

        {currentFormIndex === forms.length-1 ? (
          <>
            {formType === ScopeWorkflowFormType.ADD && (
              <Button className="next-scope-form-button" type="full" title="Add" onClick={onNext} />
            )}

            {formType === ScopeWorkflowFormType.VIEW && (
              <Button className="next-scope-form-button" type="full" title="Done" onClick={onNext} />
            )}

            {formType === ScopeWorkflowFormType.EDIT && (
              <Button className="next-scope-form-button" type="full" title="Edit" onClick={onNext} />
            )}
          </>
        ) : (
          <Button className="next-scope-form-button" type="full" title="Next" onClick={onNext} />
        )}
        
      </div>
    </Alert>
  )
}

export default AddWorkflowForm;